<div class="container-fluid p-0 white">
  <app-header [title]="title"></app-header>
  <!-- <h1>checklist : {{AgentdeallocationForm.value.checklist }}</h1> -->
  <div class="col-md-12 col-sm-12 col-sm-12 p-0">
    <div class="col-md-12 col-sm-12 p-0 super-deallocation">
      <form class="form-horizontal" role="form" [formGroup]="AgentdeallocationForm" (ngSubmit)="submitFrom()">
        <div class="deallocation-bucket text-center pv-10">
          <div class="col-md-12 p-0">
            <div class="form-group mb-0" (change)="ClientSelectDropdown($event)">
              <!-- form value : {{getFormValue()}} -->
              <div>
                <label class=" label-std control-label p-0 b-600 pl-0" for="">Client</label>
                <app-common-dropdown-search *ngIf="ClientList.length > 0" [data]="ClientList" [addFieldSetting]="addFieldSetting" (callEvent)="ClientListOnChange($event)"></app-common-dropdown-search>
                <!-- <select class="form-control" formControlName="ClientId" placeholder="d.ff"
                  (change)="ClientListOnChange()">
                  <option [value]="''" disabled>Select</option>
                  <option *ngFor="let Client of ClientList" [value]="Client.Client_Id">{{Client.Client_Name}}
                  </option>
                </select> -->
              </div>
            </div>
            <div class="form-group" *ngIf="showOptionButtons">
              <label class=" label-std control-label p-0 b-600 pl-0" for="">Check Option</label>
              <div class="radioBorder">
                <label class="radio-inline">
                  <input type="radio" name="checklist" value="byModule" formControlName="checklist"
                    (change)="OpenByModule($event)"> By Module </label>
                <label class="radio-inline">
                  <input type="radio" name="checklist" value="byAgent" formControlName="checklist"
                    (change)="OpenByAgent($event)"> By Agent</label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="AgentdeallocationForm.value as formValue">
  <!-- commented for now -->
  <app-project-and-priority-deallocation-page [ClientId]="formValue.ClientId" [employeeList]="employeeList"
    [moduleList]="moduleList" [viewBy]="formValue.checklist" *ngIf="formValue && formValue.checklist!=null"
    (close)="closeModal($event)"></app-project-and-priority-deallocation-page>
  <!-- <app-concluder-deallocation-page [ClientId]="formValue.ClientId" [employeeList]="employeeList"
    [moduleList]="moduleList" [viewBy]="formValue.checklist" *ngIf="formValue && formValue.checklist!=null"
    (close)="closeModal($event)">
  </app-concluder-deallocation-page> -->
</div>
